module.exports = __webpack_public_path__ + "img/3.75ee044e.jpg";